/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";
import {
    UpdatePieceFileChangeTempoMutation$variables
} from "mutation/__generated__/UpdatePieceFileChangeTempoMutation.graphql";
import perform from "mutation/perform";

const mutation = graphql`
    mutation UpdatePieceFileChangeTempoMutation($input: MusicUpdatePieceFileChangeTempoInput!) {
        music_update_piece_file_change_tempo(input: $input) {
            piece {
                id
                ...PiecePlayBody_piece
                ...PieceSettingsBody_piece
            }
        }
    }
`;

export default function UpdatePieceFileChangeTempo(pieceId: string, tempo: number) {
    const variables: UpdatePieceFileChangeTempoMutation$variables = {
        input: {
            piece_id: pieceId,
            tempo_bpm: tempo
        }
    };
    return perform(mutation, variables);
}